import http from "@/api/http.js";
import { isLogged } from "@/middleware/Auth.js";
import router from "../../router";
import { getSavedState, saveState } from "@/helpers/LocalStorage.js";

export const state = {
  currentUser: getSavedState("auth.currentUser")
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    saveState("auth.currentUser", newValue);
  }
};

export const getters = {
  // Whether the user is currently logged in.
  currentUserPermissions(state) {
    if (!state.currentUser || !state.currentUser.access) {
      return [];
    }
    return state.currentUser.access.split(",");
  },
  hasRole: state => roles => {
    if (!state.currentUser || !state.currentUser.role) {
      return false;
    }
    for (const role of roles) {
      if (state.currentUser.role.split(",").includes(role)) {
        return true;
      }
    }
    return false;
  },
  loggedIn(state) {
    return !!state.currentUser;
  },
  currentUser(state) {
    return state.currentUser;
  },
  currentToken(state) {
    return state.currentUser ? state.currentUser.token : "";
  },
  // superadmin tiene todos los permisos, igual que userCan() en el backend
  // (authorization_helper.php). Sin esto el front le niega acciones que la API
  // si le permite.
  isSuperadmin(state, getters) {
    return getters.hasRole(["superadmin"]);
  },
  userHasPermission: (state, getters) => permission => {
    if (getters.isSuperadmin) {
      return true;
    }
    if (!state.currentUser || !state.currentUser.access) {
      return false;
    }
    return state.currentUser.access.split(",").includes(permission);
  }
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ dispatch }) {
    dispatch("validate");
  },

  // Logs in the current user.
  logIn({ commit, dispatch }, { email, password } = {}) {
    if (isLogged()) return dispatch("validate");
    return http
      .post(process.env.VUE_APP_MAIN_ADMIN_API + "auth/login", {
        email,
        password
      })
      .then(response => {
        if (response.status == "success") {
          const user = response;
          commit("SET_CURRENT_USER", user);
          return true;
        } else {
          return response;
        }
      })
      .catch(e => {
        throw e;
      });
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit("SET_CURRENT_USER", null);
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit }) {
    if (!isLogged()) return Promise.resolve(null);

    return http
      .get("/auth/refresh_token")
      .then(response => {
        const user = response;
        commit("SET_CURRENT_USER", user);
        return user;
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          commit("SET_CURRENT_USER", null);
          console.log("User is not authorized, going to login");
          router.push("login");
        } else {
          // eslint-disable-next-line no-console
          console.warn(error);
        }
        return null;
      });
  }
};
